/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ShiftSwap } from './ShiftSwap';
import {
    ShiftSwapFromJSON,
    ShiftSwapFromJSONTyped,
    ShiftSwapToJSON,
    ShiftSwapToJSONTyped,
} from './ShiftSwap';

/**
 * 
 * @export
 * @interface DeclineShiftSwapResponse
 */
export interface DeclineShiftSwapResponse {
    /**
     * 
     * @type {ShiftSwap}
     * @memberof DeclineShiftSwapResponse
     */
    data: ShiftSwap;
}

/**
 * Check if a given object implements the DeclineShiftSwapResponse interface.
 */
export function instanceOfDeclineShiftSwapResponse(value: object): value is DeclineShiftSwapResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function DeclineShiftSwapResponseFromJSON(json: any): DeclineShiftSwapResponse {
    return DeclineShiftSwapResponseFromJSONTyped(json, false);
}

export function DeclineShiftSwapResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): DeclineShiftSwapResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': ShiftSwapFromJSON(json['data']),
    };
}

  export function DeclineShiftSwapResponseToJSON(json: any): DeclineShiftSwapResponse {
      return DeclineShiftSwapResponseToJSONTyped(json, false);
  }

  export function DeclineShiftSwapResponseToJSONTyped(value?: DeclineShiftSwapResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': ShiftSwapToJSON(value['data']),
    };
}

